import {
  createStaffCatalogApi,
  createStaffItineraryApi,
  createStaffRequestsApi,
} from "@lafayette/api-client";

import { currentAccessToken } from "../catalog/admin-runtime";
import { getAdminPublicConfig } from "../config/public-config";
import type { ItineraryRuntime } from "./runtime";

/** The runtime of the real admin app: the typed clients over `fetch` and the clock. The token comes from the one shared function. */
export function createAdminItineraryRuntime(): ItineraryRuntime {
  const options = {
    baseUrl: getAdminPublicConfig().apiUrl.toString(),
    getAccessToken: currentAccessToken,
  };
  return {
    api: createStaffItineraryApi(options),
    catalog: createStaffCatalogApi(options),
    requests: createStaffRequestsApi(options),
    now: () => new Date(),
    requestRefreshMs: 30_000,
  };
}
